import { getCurrentFocusKey, setFocus } from '@noriginmedia/norigin-spatial-navigation';
import { ROUTE_ARCHIVE, ROUTE_HOME, ROUTE_INBOX, ROUTE_SIGN_IN } from 'common/config/constants';
import variables from 'common/config/variables';
import FocusHistory from 'common/utils/FocusHistory';
import { StoreState } from 'index';
import { isNumber } from 'lodash';
import { useCallback } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { getKey, waitFor } from '..';

type Route = string | number;

export const history: string[] = [];

const popHistory = (page: Route) => {
  if (isNumber(page)) {
    history.splice(history.length + page, Math.abs(page));
  }
};

const pushHistory = (page: Route) => {
  if (history[history.length - 1] !== page) history.push(page as string);
};

const isPrevious = (page: Route) => {
  return isNumber(page) && page < 0;
};

const usePageNavigation = () => {
  const innerNavigate = useNavigate();
  //   const processBeforeNavigate = (page: Route) => {};
  const virtualDebugerEnabled = useSelector(
    (state: StoreState) => state.appConfig.virtualDebuggerEnabled,
    shallowEqual
  ) as boolean;

  const processAfterNavigate = useCallback((page: Route) => {
    // Check if going to previous page
    const prevPath = history[history.length - 1];
    const previous = prevPath && FocusHistory.getPreviousByPath(prevPath);
    if (isPrevious(page) && previous) {
      setFocus(previous.focusKey);
      return;
    }
    //Else handle normally
    switch (page) {
      case ROUTE_HOME:
      case ROUTE_ARCHIVE:
        setFocus(getKey('stripe', 0, page));
        break;
      case ROUTE_SIGN_IN:
        setFocus(getKey('input', 'email'));
        break;
      case ROUTE_INBOX:
        break;
      default:
        {
          waitFor(() => {
            const key =
              '/' + getKey('stripe-view', undefined, isPrevious(page) ? prevPath : String(page));
            setFocus(key);
            return false;
          }, variables.THROTTLE_TIMEOUT);
        }
        break;
    }
  }, []);

  const navigate = useCallback(
    (page: Route, withoutProcess?: boolean, replace?: boolean) => {
      if (virtualDebugerEnabled) {
        const targetObject = { page, withoutProcess, replace };
        Error.captureStackTrace(targetObject);
        // @ts-ignore
        console.log(targetObject.stack);
      }
      const prevFocusKey = getCurrentFocusKey();
      // processBeforeNavigate(page);
      FocusHistory.setPrevious(prevFocusKey, location.pathname);
      innerNavigate(page as any, { replace });
      const previous = isPrevious(page);
      previous ? popHistory(page) : pushHistory(location.pathname);
      !withoutProcess && processAfterNavigate(page);
      FocusHistory.setCurrent(getCurrentFocusKey(), location.pathname);
      // if (isPrevious(page)) {
      //   FocusHistory.clearHistoryForPath(location.pathname);
      // }
    },
    [location.pathname, virtualDebugerEnabled]
  );

  return navigate;
};

export default usePageNavigation;
